import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyBook } from "@/components/StickyBook";

export const Layout = ({ children }) => (
  <div className="relative min-h-screen bg-ink">
    <Navbar />
    <main>{children}</main>
    <Footer />
    <StickyBook />
  </div>
);
